export const parseIdentity = (identity = {}) => {
  if (!!identity) {
    const { value, valueName } = identity;
    return { [valueName]: value };
  }
};
